import { render, staticRenderFns } from "./PopoverPenal.vue?vue&type=template&id=1fd7d5d0&scoped=true"
import script from "./PopoverPenal.vue?vue&type=script&lang=js"
export * from "./PopoverPenal.vue?vue&type=script&lang=js"
import style0 from "./PopoverPenal.vue?vue&type=style&index=0&id=1fd7d5d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd7d5d0",
  null
  
)

export default component.exports